import React, { useState } from 'react';

export default function NewsletterDebugProbe() {
  const [status, setStatus] = useState('');
  const [result, setResult] = useState('');

  const runTest = async () => {
    setStatus('Testing...');
    setResult('');

    try {
      const response = await fetch(
        "https://qtrbb6sdvc.execute-api.us-east-1.amazonaws.com/prod/newsletter",
        {
          method: "POST",
          headers: { "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "POST,OPTIONS",
            "Access-Control-Allow-Headers": "Content-Type,Authorization"
           },
          body: JSON.stringify({ email: "contact@iurix.com" }),
        }
      );

      const text = await response.text();
      setStatus(`HTTP ${response.status}`);
      setResult(text);
      console.log("response:", text);
    } catch (error) {
      setStatus("Fetch failed");
      setResult(String(error));
      console.error("fetch error:", error);
    }
  };

  return (
    <div style={{ maxWidth: 700, margin: "40px auto", fontFamily: "sans-serif" }}>
      <button onClick={runTest}>Test Newsletter API</button>
      <p>{status}</p>
      <pre style={{ whiteSpace: "pre-wrap", background: "#111827", color: "#fff", padding: 16 }}>
        {result || "No response yet"}
      </pre>
    </div>
  );
}